import { AuthorColumn } from './columns/CreatedListTable/Author/Author';
import { CreatedDateColumn } from './columns/CreatedListTable/CreatedDate/CreatedDate';
import { NameColumn } from './columns/CreatedListTable/Name/Name';
import { ChecklistNameColumn } from './columns/ReceivedListTable/ChecklistName/ChecklistNameColumn';
import { DriverNameColumn } from './columns/ReceivedListTable/DriverName/DriverNameColumn';
import { ReceivedDateColumn } from './columns/ReceivedListTable/ReceivedDate/ReceivedDateColumn';
import { ReceivedTimeColumn } from './columns/ReceivedListTable/ReceivedTime/ReceivedTimeColumn';
import { VehicleColumn } from './columns/ReceivedListTable/Vehicle/VehicleColumn';

import type { Checklist } from '@cobliteam/api-lib';

import type { ITableColumn } from '@cobliteam/base-components';

export const createdListColumns = (): Array<ITableColumn<Checklist>> => [NameColumn(), AuthorColumn(), CreatedDateColumn()];

export const receivedListColumns = (): Array<ITableColumn<Checklist>> => [ReceivedDateColumn(), ReceivedTimeColumn(), ChecklistNameColumn(), VehicleColumn(), DriverNameColumn()];
